import axios from "axios";

const API = axios.create({
  baseURL: "https://apis.bulk.datta-krupa.co.in"
});

export const uploadExcel = (file, onUploadProgress) => {
  const formData = new FormData();
  formData.append("file", file);

  return API.post("/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress
  });
};